import { Service } from '@/services/api';
import type {
  DashboardLayout,
  DashboardWidget,
  DashboardWidgetCreatePayload,
  DashboardWidgetMovePayload,
  DashboardWidgetUpdatePayload,
} from '@/types/v2/DashboardWidget';

class DashboardWidgetService extends Service {
  async list(): Promise<DashboardWidget[]> {
    return this.get<DashboardWidget[]>('/v1/dashboard-widget').then(this.handleResponse);
  }

  async getLayout(): Promise<DashboardLayout> {
    return this.get<DashboardLayout>('/v1/dashboard-layout').then(this.handleResponse);
  }

  async createColumn(colSpan = 1): Promise<void> {
    return this.post<void>('/v1/dashboard-column', { colSpan }).then(this.handleResponse);
  }

  async updateColumn(id: number, colSpan: number): Promise<void> {
    return this.patch<void>(`/v1/dashboard-column/${id}`, { colSpan }).then(this.handleResponse);
  }

  async removeColumn(id: number): Promise<void> {
    return this.delete<void>(`/v1/dashboard-column/${id}`).then(this.handleResponse);
  }

  async reorderColumns(ids: number[]): Promise<void> {
    return this.put<void>('/v1/dashboard-column/reorder', { ids }).then(this.handleResponse);
  }

  async create(payload: DashboardWidgetCreatePayload): Promise<void> {
    return this.post<void>('/v1/dashboard-widget', payload).then(this.handleResponse);
  }

  async update(id: number, payload: DashboardWidgetUpdatePayload): Promise<void> {
    return this.patch<void>(`/v1/dashboard-widget/${id}`, payload).then(this.handleResponse);
  }

  async remove(id: number): Promise<void> {
    return this.delete<void>(`/v1/dashboard-widget/${id}`).then(this.handleResponse);
  }

  async reorder(columnId: number, ids: number[]): Promise<void> {
    return this.put<void>('/v1/dashboard-widget/reorder', { columnId, ids }).then(this.handleResponse);
  }

  async move(id: number, payload: DashboardWidgetMovePayload): Promise<void> {
    return this.put<void>(`/v1/dashboard-widget/${id}/move`, payload).then(this.handleResponse);
  }
}

export default new DashboardWidgetService();
